module.exports = __webpack_public_path__ + "img/screen-recording.b9b9b3f8.svg";